import { Html } from '@react-three/drei';
import { EmptyState, MantineOverrideProvider } from '@uag/react-core';
import { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import 'app/modules/wallforming/custom-styles/customEmptyStateStyle.css';

interface ErrorBoundaryFallbackProps {
    error: FallbackProps['error'];
    withinCanvas: boolean;
    title?: string;
    description?: string;
}

export const ErrorBoundaryFallback = ({ error, withinCanvas, title, description }: ErrorBoundaryFallbackProps) => {
    const { t } = useTranslation();
    if (!withinCanvas) {
        return (
            <div className="flex items-center justify-center h-full w-full bg-none">
                <EmptyState
                    className="whitespace-normal wrap-break-word max-w-full"
                    icon="error"
                    title={title ?? t(error.name)}
                >
                    {description ?? t(error.message)}
                </EmptyState>
            </div>
        );
    }
    return (
        <Html zIndexRange={[0, 0]} fullscreen>
            <MantineOverrideProvider>
                <div className="flex items-center justify-center h-full w-full bg-none">
                    <EmptyState
                        className="whitespace-normal wrap-break-word max-w-full"
                        icon="error"
                        title={title ?? t(error.name)}
                    >
                        {description ?? t(error.message)}
                    </EmptyState>
                </div>
            </MantineOverrideProvider>
        </Html>
    );
};
